// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import BundleProductItem from '@tcp/core/src/components/features/browse/BundleProduct/molecules/BundleProductsGrid/views/BundleProductItem.view.jsx';
import { showOOSproduct } from '@tcp/core/src/components/features/browse/OutfitDetails/util.js';
import styles from '../styles/BundleProductsGrid.style';

const BundleProductsGrid = ({
  className,
  currentBundle,
  alternateBrand,
  currencySymbol,
  currencyAttributes,
  isHideOriginalPriceAndMarchantTagEnabled,
  isBundleOutfitInfluencerHandleEnabled,
  isInfluencerPicksEnabled,
  isNewSwatchUrlEnabled,
  onQuickViewOpenClick,
  promotionsData,
  isUpdatedPromotionsDisplayEnabled,
  serverTime,
  isBuyMorePromoEnabled,
  isDynamicBadgeEnabled,
  resetSlpLoadingState,
  inYourBagProducts,
  isKeepAliveEnabled,
  isSplittingExtendedSizesEnabled,
}) => {
  return (
    <ul className={`${className} products-list-grid`}>
      {currentBundle?.map((product) => {
        const productItem = product?.products;
        const primaryBrand = productItem?.primaryBrand || alternateBrand;
        return productItem && showOOSproduct(productItem, isKeepAliveEnabled) ? (
          <li key={productItem.productId} className="product-list-item">
            <BundleProductItem
              productItem={productItem}
              currencySymbol={currencySymbol}
              currencyAttributes={currencyAttributes}
              primaryBrand={primaryBrand || alternateBrand}
              alternateBrand={alternateBrand}
              isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
              isBundleOutfitInfluencerHandleEnabled={isBundleOutfitInfluencerHandleEnabled}
              isInfluencerPicksEnabled={isInfluencerPicksEnabled}
              isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
              onQuickViewOpenClick={onQuickViewOpenClick}
              promotionsData={promotionsData}
              isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
              serverTime={serverTime}
              isBuyMorePromoEnabled={isBuyMorePromoEnabled}
              isDynamicBadgeEnabled={isDynamicBadgeEnabled}
              resetSlpLoadingState={resetSlpLoadingState}
              inYourBagProducts={inYourBagProducts}
              isKeepAliveEnabled={isKeepAliveEnabled}
              isSplittingExtendedSizesEnabled={isSplittingExtendedSizesEnabled}
            />
          </li>
        ) : null;
      })}
    </ul>
  );
};

BundleProductsGrid.propTypes = {
  className: PropTypes.string.isRequired,
  onQuickViewOpenClick: PropTypes.func,
  isInfluencerPicksEnabled: PropTypes.bool,
  isNewSwatchUrlEnabled: PropTypes.bool,
  currencySymbol: PropTypes.string,
  promotionsData: PropTypes.shape({}),
  isUpdatedPromotionsDisplayEnabled: PropTypes.bool,
  serverTime: PropTypes.number,
  isBuyMorePromoEnabled: PropTypes.bool,
  resetSlpLoadingState: PropTypes.func,
  isHideOriginalPriceAndMarchantTagEnabled: PropTypes.bool,
  isBundleOutfitInfluencerHandleEnabled: PropTypes.bool,
  currentBundle: PropTypes.arrayOf(PropTypes.shape({})),
  currencyAttributes: PropTypes.shape({}),
  isDynamicBadgeEnabled: PropTypes.shape({}),
  alternateBrand: PropTypes.string,
  isKeepAliveEnabled: PropTypes.bool,
};

BundleProductsGrid.defaultProps = {
  onQuickViewOpenClick: () => {},
  isInfluencerPicksEnabled: false,
  isNewSwatchUrlEnabled: false,
  currencySymbol: '$',
  promotionsData: {},
  isUpdatedPromotionsDisplayEnabled: false,
  serverTime: null,
  isBuyMorePromoEnabled: false,
  resetSlpLoadingState: () => {},
  isHideOriginalPriceAndMarchantTagEnabled: false,
  isBundleOutfitInfluencerHandleEnabled: false,
  currentBundle: [],
  currencyAttributes: {},
  isDynamicBadgeEnabled: {},
  alternateBrand: '',
  isKeepAliveEnabled: false,
};

export default withStyles(BundleProductsGrid, styles);
export { BundleProductsGrid as BundleProductsGridVanilla };
